// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__3lPpE","logo":"Menu_logo__FJlLm","item":"Menu_item__wME+B"};